(function () {
    const header = document.getElementById('header');
    const hero = document.querySelector('.hero');
    const body = document.body;
    let lastScrollTop = 0;

    if (!header) return;

    const headerHeight = header.offsetHeight;

    // check has class website--active

    function onScroll() {
        const scrollTop =
            window.pageXOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop ||
            0;
        const hasWebsiteActiveClass = body.classList.contains('website--active');

        if (!hero) {
            if (scrollTop > 0) {
                body.classList.add('header--dark');
            } else {
                body.classList.remove('header--dark');
            }
            if (scrollTop > lastScrollTop) {
                body.classList.add('header--scrolled');
            } else {
                body.classList.remove('header--scrolled');
            }
        } else {
            if (hasWebsiteActiveClass) {
                if (scrollTop > lastScrollTop && scrollTop > window.innerHeight * 2) {
                    body.classList.add('header--scrolled');
                } else {
                    body.classList.remove('header--scrolled');
                }
            }
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }

    window.addEventListener('scroll', onScroll);
    onScroll();
})();

// set chiều cao cho .page-line__line dọc theo màn hình khi scroll
(function () {
    const pageLines = document.querySelectorAll('.page-line__line');
    if (pageLines.length === 0) return;

    function onScroll() {
        const scrollY = window.scrollY;
        const viewportHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;

        // Tính toán chiều cao của .page-line__line dựa trên scroll
        const lineHeight = (scrollY / (documentHeight - viewportHeight)) * 100;

        pageLines.forEach(pageLine => {
            pageLine.style.height = `${lineHeight}%`;
        });
    }

    window.addEventListener('scroll', onScroll);
    onScroll();
})();

function initGsapTextReveal(zoneId = 'reveal-zone') {
    const zone = document.getElementById(zoneId);
    if (!zone) return;

    const revealEls = [...zone.querySelectorAll('[data-reveal]')];

    // 1. Hàm tách chữ (Giữ nguyên logic gốc của bạn)
    function splitToSpans(el) {
        if (el.dataset._split) return;
        const text = el.textContent;
        el.textContent = '';

        const tokens = [...text.matchAll(/\S+|\s+/g)].map(m => m[0]);

        for (const token of tokens) {
            if (/\s/.test(token)) {
                el.appendChild(document.createTextNode(token));
            } else {
                const word = document.createElement('span');
                word.className = 'srp-word';
                word.style.display = 'inline-block';
                word.style.whiteSpace = 'nowrap';

                for (const ch of [...token]) {
                    const span = document.createElement('span');
                    span.className = 'srp-ch';
                    span.textContent = ch;
                    word.appendChild(span);
                }
                el.appendChild(word);
            }
        }
        el.dataset._split = '1';
    }

    // Thực hiện tách chữ cho tất cả phần tử
    revealEls.forEach(splitToSpans);

    // 2. Tích hợp vào GSAP ScrollTrigger cho từng phần tử
    revealEls.forEach(el => {
        const chars = el.querySelectorAll('.srp-ch');

        gsap.to(el, {
            scrollTrigger: {
                trigger: el, // Kích hoạt khi cuộn tới chính phần tử này
                start: 'top 80%', // Tương đương startOffset = 80 của bạn (cách đáy màn hình 20%)
                end: 'top 20%', // Điểm kết thúc hiệu ứng (thay cho endOffset cố định)
                scrub: true, // Buộc hiệu ứng chạy mượt chạy theo tiến độ cuộn chuột
                // markers: true,       // Bật dòng này nếu muốn bật thước đo để căn chỉnh vị trí start/end

                // Hàm này chạy liên tục khi cuộn qua lại trong vùng start -> end
                onUpdate: self => {
                    const p = self.progress; // GSAP tự trả về giá trị từ 0 đến 1
                    const n = Math.floor(p * chars.length);

                    chars.forEach((c, i) => {
                        c.classList.toggle('srp-ch--on', i < n);
                    });
                },
            },
        });
    });
}

function initCanvasDissolve() {
    const canvas = document.querySelector('#dissolve-canvas-vertical');
    const productSection = document.querySelector('.product');

    if (!canvas || !productSection) return;
    if (typeof window.gsap === 'undefined' || typeof window.ScrollTrigger === 'undefined') return;
    if (typeof window.THREE === 'undefined') return;

    const gsapInstance = window.gsap;
    const ScrollTriggerInstance = window.ScrollTrigger;
    const THREEInstance = window.THREE;

    // Đăng ký Plugin ScrollTrigger
    gsapInstance.registerPlugin(ScrollTriggerInstance);

    // --- 1. SETUP THREE.JS SCENE ---
    const scene = new THREEInstance.Scene();
    const camera = new THREEInstance.OrthographicCamera(-1, 1, 1, -1, 0, 1);
    const renderer = new THREEInstance.WebGLRenderer({ canvas: canvas, alpha: true });

    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

    // --- 2. SHADER CODES (GLSL) ---
    const vertexShader = `
        varying vec2 vUv;
        void main() {
            vUv = uv;
            gl_Position = vec4(position, 1.0);
        }
    `;

    let fragmentShader = `
        uniform float uProgress;
        varying vec2 vUv;

        float hash(vec2 p) {
            p = fract(p * vec2(123.34, 456.21));
            p += dot(p, p + 45.32);
            return fract(p.x * p.y);
        }

        float noise(vec2 p) {
            vec2 i = floor(p);
            vec2 f = fract(p);
            f = f * f * (3.0 - 2.0 * f);
            float a = hash(i);
            float b = hash(i + vec2(1.0, 0.0));
            float c = hash(i + vec2(0.0, 1.0));
            float d = hash(i + vec2(1.0, 1.0));
            return mix(mix(a, b, f.x), mix(c, d, f.x), f.y);
        }

        void main() {
            vec4 color = vec4(1.0 / 255.0, 51.0 / 255.0, 42.0 / 255.0, 1.0);
            float noiseValue = noise(vUv * 20.0);
            float transitionFactor = noiseValue * 0.4 + vUv.y * 0.6;
            float currentThreshold = uProgress * 1.3;

            if (transitionFactor > currentThreshold) {
                color.a = 1.0;
            } else {
                color.a = 0.0;
            }
            gl_FragColor = color;
        }
    `;

    let isMobile = window.matchMedia('(max-width: 991px)').matches;
    let endsection = 'bottom top';
    let startSection = 'top center';

    if (isMobile) {
        fragmentShader = `
            uniform float uProgress;
            varying vec2 vUv;

            float hash(vec2 p) {
                p = fract(p * vec2(123.34, 456.21));
                p += dot(p, p + 45.32);
                return fract(p.x * p.y);
            }

            float noise(vec2 p) {
                vec2 i = floor(p);
                vec2 f = fract(p);
                f = f * f * (3.0 - 2.0 * f);
                float a = hash(i);
                float b = hash(i + vec2(1.0, 0.0));
                float c = hash(i + vec2(0.0, 1.0));
                float d = hash(i + vec2(1.0, 1.0));
                return mix(mix(a, b, f.x), mix(c, d, f.x), f.y);
            }

            void main() {
                vec4 color = vec4(1.0 / 255.0, 51.0 / 255.0, 42.0 / 255.0, 1.0);
                float noiseValue = noise(vUv * 15.0);
                float transitionFactor = noiseValue * 0.4 + vUv.y * 2.2;
                float currentThreshold = uProgress * 3.0;

                if (transitionFactor > currentThreshold) {
                    color.a = 1.0;
                } else {
                    color.a = 0.0;
                }
                gl_FragColor = color;
            }
        `;

        const windowScrollHeight =
            window.innerHeight ||
            document.documentElement.clientHeight ||
            document.body.clientHeight;

        startSection = `top bottom`;
        endsection = `bottom center`;
    }

    // Biến truyền vào Shader (Uniforms)
    const shaderUniforms = {
        uProgress: { value: 0.0 },
    };

    const geometry = new THREEInstance.PlaneGeometry(2, 2);
    const material = new THREEInstance.ShaderMaterial({
        vertexShader: vertexShader,
        fragmentShader: fragmentShader,
        uniforms: shaderUniforms,
        transparent: true,
    });

    const mesh = new THREEInstance.Mesh(geometry, material); // Tạo mesh từ geometry và material
    scene.add(mesh); // Thêm mesh vào scene

    // --- 3. RÁP NỐI VÀO GSAP SCROLLTRIGGER (Đã tối ưu cho Smoother) ---
    gsapInstance.to(shaderUniforms.uProgress, {
        value: 1.0,
        scrollTrigger: {
            trigger: productSection,
            start: 'top center', // Bắt đầu khi phần tử productSection chạm đáy màn hình
            end: endsection, // Kết thúc khi phần tử productSection chạm đỉnh
            scrub: true, // Chuyển từ scrub: 1 thành true. Vì bản thân ScrollSmoother đã có độ trễ mượt sẵn (smooth), bạn để scrub: true sẽ giúp shader phản hồi real-time chính xác theo mượt của smoother, tránh bị "trễ chồng trễ" (double lag).
        },
        // Loại bỏ hàm onUpdate ở đây, chuyển hoàn toàn việc vẽ vào vòng lặp animate()
    });

    // --- 4. XỬ LÝ RESIZE TRÌNH DUYỆT ---
    window.addEventListener('resize', () => {
        renderer.setSize(window.innerWidth, window.innerHeight);
        renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    });

    // --- 5. VÒNG LẶP ANIMATION HOÀN CHỈNH ---
    function animate() {
        requestAnimationFrame(animate);
        renderer.render(scene, camera);
    }

    // Kích hoạt vòng lặp vẽ
    animate();
}

function initFadeInOnScroll(selectors) {
    if (typeof window.gsap === 'undefined' || typeof window.ScrollTrigger === 'undefined') return;

    const gsapInstance = window.gsap;
    const ScrollTriggerInstance = window.ScrollTrigger;
    gsapInstance.registerPlugin(ScrollTriggerInstance);

    const elements = [
        ...new Set(selectors.flatMap(selector => [...document.querySelectorAll(selector)])),
    ];

    if (elements.length === 0) return;

    gsapInstance.set(elements, {
        autoAlpha: 0,
        y: 24,
    });

    elements.forEach(element => {
        gsapInstance.fromTo(
            element,
            {
                autoAlpha: 0,
                y: 24,
            },
            {
                autoAlpha: 1,
                y: 0,
                duration: 0.8,
                ease: 'power2.out',
                clearProps: 'transform,opacity,visibility',
                scrollTrigger: {
                    trigger: element,
                    start: 'top 85%',
                    end: 'top 55%',
                    toggleActions: 'play none none reverse',
                    invalidateOnRefresh: true,
                },
            }
        );
    });
}

function initBannerIconPhysicalEvade() {
    const iconElements = [...document.querySelectorAll('.banner__icon')];
    if (iconElements.length === 0) return;

    const states = iconElements
        .map(el => {
            const wrapper = el.closest('.banner__wrapper');
            if (!wrapper) return null;

            return {
                el,
                wrapper,
                x: 0,
                y: 0,
                vx: 0,
                vy: 0,
                rotation: 0,
                minX: -Infinity,
                maxX: Infinity,
                minY: -Infinity,
                maxY: Infinity,
            };
        })
        .filter(Boolean);

    if (states.length === 0) return;

    const stateByElement = new WeakMap();
    states.forEach(state => {
        stateByElement.set(state.el, state);
    });

    const HOVER_IMPULSE = 4;
    const GRAVITY = 0.08;
    const FALL_GRAVITY_MULTIPLIER = 2;
    const BOUNCE = 0.3;
    const FRICTION = 0.997;
    const MIN_SPEED = 0.02;
    let rafId = null;

    function updateBounds() {
        states.forEach(state => {
            const rect = state.el.getBoundingClientRect();
            const baseLeft = rect.left - state.x;
            const baseRight = rect.right - state.x;
            const baseTop = rect.top - state.y;
            const baseBottom = rect.bottom - state.y;

            const wrapperRect = state.wrapper.getBoundingClientRect();
            state.minX = wrapperRect.left - baseLeft;
            state.maxX = wrapperRect.right - baseRight;
            state.minY = wrapperRect.top - baseTop;
            state.maxY = wrapperRect.bottom - baseBottom;

            state.el.style.willChange = 'transform';
        });
    }

    function renderState(state) {
        state.el.style.transform = `translate3d(${state.x}px, ${state.y}px, 0) rotate(${state.rotation}deg)`;
    }

    function addImpulse(state, ix, iy) {
        state.vx += ix;
        state.vy += iy;
        ensureTicking();
    }

    function tick() {
        let hasMotion = false;

        states.forEach(state => {
            state.vy += state.vy > 0 ? GRAVITY * FALL_GRAVITY_MULTIPLIER : GRAVITY;
            state.vx *= FRICTION;
            state.vy *= FRICTION;
            state.x += state.vx;
            state.y += state.vy;

            if (state.x <= state.minX) {
                state.x = state.minX;
                state.vx = Math.abs(state.vx) * BOUNCE;
            } else if (state.x >= state.maxX) {
                state.x = state.maxX;
                state.vx = -Math.abs(state.vx) * BOUNCE;
            }

            if (state.y <= state.minY) {
                state.y = state.minY;
                state.vy = Math.abs(state.vy) * BOUNCE;
            } else if (state.y >= state.maxY) {
                state.y = state.maxY;
                state.vy = -Math.abs(state.vy) * BOUNCE;

                // Settle on floor so the icon naturally ends at bottom.
                if (Math.abs(state.vy) < 0.6) {
                    state.vy = 0;
                    state.vx *= 0.72;
                }
            }

            // Roll angle tied to movement so it feels like a ball.
            state.rotation += (state.vx + state.vy * 0.35) * 4;
            renderState(state);

            if (Math.abs(state.vx) < MIN_SPEED) state.vx = 0;
            if (Math.abs(state.vy) < MIN_SPEED) state.vy = 0;

            if (state.vx !== 0 || state.vy !== 0) {
                hasMotion = true;
            }
        });

        if (hasMotion) {
            rafId = requestAnimationFrame(tick);
            return;
        }

        rafId = null;
    }

    function ensureTicking() {
        if (rafId !== null) return;
        rafId = requestAnimationFrame(tick);
    }

    function handleIconPointerEnter(event) {
        const state = stateByElement.get(event.currentTarget);
        if (!state) return;

        const rect = state.el.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;
        const dx = centerX - event.clientX;
        const dy = centerY - event.clientY;
        const distance = Math.hypot(dx, dy);

        let nx = 0;
        let ny = 0;

        if (distance > 0.0001) {
            nx = dx / distance;
            ny = dy / distance;
        } else {
            const angle = Math.random() * Math.PI * 2;
            nx = Math.cos(angle);
            ny = Math.sin(angle);
        }

        addImpulse(state, nx * HOVER_IMPULSE, ny * HOVER_IMPULSE);
    }

    updateBounds();
    window.addEventListener('resize', updateBounds);
    window.addEventListener('scroll', updateBounds, { passive: true });

    states.forEach(state => {
        state.el.addEventListener('pointerenter', handleIconPointerEnter, { passive: true });
    });
}

function initAboutsIconScrollSwap() {
    const aboutsSection = document.querySelector('.abouts');
    const iconWrapper = document.querySelector('.abouts__images-icon');

    if (!aboutsSection || !iconWrapper) return;
    if (typeof window.gsap === 'undefined' || typeof window.ScrollTrigger === 'undefined') return;

    const imageEl = iconWrapper.querySelector('img');
    if (!imageEl) return;

    const rawImages = iconWrapper.getAttribute('data-images') || '[]';
    const images = (() => {
        try {
            return JSON.parse(rawImages.replace(/'/g, '"')).filter(Boolean);
        } catch (error) {
            return [];
        }
    })();

    if (images.length === 0) return;

    const gsapInstance = window.gsap;
    const ScrollTriggerInstance = window.ScrollTrigger;
    gsapInstance.registerPlugin(ScrollTriggerInstance);

    const ACTIVE_START = 0.2;
    const ACTIVE_END = 0.8;
    const totalSteps = images.length - 1;
    let currentIndex = -1;
    let pendingIndex = null;
    let isTransitioning = false;

    gsapInstance.set(imageEl, {
        autoAlpha: 1,
        transformPerspective: 1200,
        transformStyle: 'preserve-3d',
        transformOrigin: '50% 50%',
        backfaceVisibility: 'hidden',
    });

    function swapToIndex(index) {
        const nextSrc = images[index];
        if (!nextSrc || index === currentIndex) return;

        if (isTransitioning) {
            pendingIndex = index;
            return;
        }

        isTransitioning = true;
        pendingIndex = null;

        gsapInstance.killTweensOf(imageEl);

        gsapInstance
            .timeline({
                defaults: { ease: 'power2.inOut' },
                onComplete: () => {
                    currentIndex = index;
                    isTransitioning = false;

                    if (pendingIndex !== null && pendingIndex !== currentIndex) {
                        const nextPending = pendingIndex;
                        pendingIndex = null;
                        swapToIndex(nextPending);
                    }
                },
            })
            .to(imageEl, {
                rotationY: 90,
                duration: 0.18,
            })
            .add(() => {
                imageEl.setAttribute('src', nextSrc);
            })
            .set(imageEl, {
                rotationY: -90,
            })
            .to(imageEl, {
                rotationY: 0,
                duration: 0.22,
            });
    }

    function setImageByProgress(progress) {
        const index = Math.min(totalSteps, Math.max(0, Math.floor(progress * images.length)));

        if (index === currentIndex) return;
        swapToIndex(index);
    }

    function getActiveProgress(progress) {
        if (progress <= ACTIVE_START) return 0;
        if (progress >= ACTIVE_END) return 1;
        return (progress - ACTIVE_START) / (ACTIVE_END - ACTIVE_START);
    }

    ScrollTriggerInstance.create({
        trigger: aboutsSection,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        invalidateOnRefresh: true,
        onUpdate: self => {
            setImageByProgress(getActiveProgress(self.progress));
        },
        onRefresh: self => {
            setImageByProgress(getActiveProgress(self.progress));
        },
    });
}

function initPartnersHorizontalScroll() {
    const partnersSection = document.querySelector('.partners');
    const partnersScroll = document.querySelector('.partners-scroll');
    const partnersContent = document.querySelector('.partners-scroll__content');
    const partnersLine = document.querySelector('.partners-scroll__line');
    const partnersLineMask = document.querySelector('.partners-scroll__line-mask');
    const partnersLineShip = document.querySelector('.partners-scroll__line-ship');
    const dissolveCanvas = document.querySelector('#dissolve-canvas');

    if (!partnersSection || !partnersScroll || !partnersContent) return;
    if (typeof window.gsap === 'undefined' || typeof window.ScrollTrigger === 'undefined') return;

    const gsapInstance = window.gsap;
    const canUseDissolve = Boolean(dissolveCanvas) && typeof window.THREE !== 'undefined';
    const THREEInstance = canUseDissolve ? window.THREE : null;

    const HOLD_DURATION = 500;
    const listenerOptions = { passive: false };
    let isEndHoldActive = false;
    let hasEndHoldCompleted = false;
    let holdTimer = null;
    let dissolveRenderer = null;
    let dissolveScene = null;
    let dissolveCamera = null;
    let dissolveUniforms = null;
    let isDissolveInitialized = false;

    function getMaxTranslateX() {
        return Math.max(0, partnersContent.scrollWidth - window.innerWidth);
    }

    function getDissolveProgress(horizontalProgress) {
        const startAt = 0.25;
        if (horizontalProgress <= startAt) return 0;
        return Math.min((horizontalProgress - startAt) / (1 - startAt), 1);
    }

    function getDissolveCanvasSize() {
        return {
            width: Math.max(window.innerWidth, partnersContent.scrollWidth),
            height: window.innerHeight,
        };
    }

    function applyDissolveCanvasSize() {
        if (!canUseDissolve) return;

        const size = getDissolveCanvasSize();
        dissolveCanvas.style.width = `${size.width}px`;
        dissolveCanvas.style.height = `${size.height}px`;

        if (dissolveRenderer) {
            dissolveRenderer.setSize(size.width, size.height, false);
        }
    }

    function createDissolveScene() {
        if (!canUseDissolve || isDissolveInitialized) return isDissolveInitialized;

        dissolveScene = new THREEInstance.Scene();
        dissolveCamera = new THREEInstance.OrthographicCamera(-1, 1, 1, -1, 0, 1);
        dissolveRenderer = new THREEInstance.WebGLRenderer({ canvas: dissolveCanvas, alpha: true });

        applyDissolveCanvasSize();
        dissolveRenderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

        const vertexShader = `
            varying vec2 vUv;
            void main() {
                vUv = uv;
                gl_Position = vec4(position, 1.0);
            }
        `;

        const fragmentShader = `
            uniform float uProgress;
            varying vec2 vUv;

            float hash(vec2 p) {
                p = fract(p * vec2(123.34, 456.21));
                p += dot(p, p + 45.32);
                return fract(p.x * p.y);
            }

            float noise(vec2 p) {
                vec2 i = floor(p);
                vec2 f = fract(p);
                f = f * f * (3.0 - 2.0 * f);
                float a = hash(i);
                float b = hash(i + vec2(1.0, 0.0));
                float c = hash(i + vec2(0.0, 1.0));
                float d = hash(i + vec2(1.0, 1.0));
                return mix(mix(a, b, f.x), mix(c, d, f.x), f.y);
            }

            void main() {
                vec4 color = vec4(1.0 / 255.0, 51.0 / 255.0, 42.0 / 255.0, 1.0);
                float noiseValue = noise(vUv * 20.0);
                float transitionFactor = noiseValue * 0.05 + (1.0 - vUv.x) * 0.6;
                float currentThreshold = uProgress * 0.6;

                if (transitionFactor > currentThreshold) {
                    color.a = 1.0;
                } else {
                    color.a = 0.0;
                }

                gl_FragColor = color;
            }
        `;

        dissolveUniforms = {
            uProgress: { value: 0.0 },
        };

        const geometry = new THREEInstance.PlaneGeometry(2, 2);
        const material = new THREEInstance.ShaderMaterial({
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            uniforms: dissolveUniforms,
            transparent: true,
        });

        const mesh = new THREEInstance.Mesh(geometry, material);
        dissolveScene.add(mesh);
        dissolveRenderer.render(dissolveScene, dissolveCamera);

        isDissolveInitialized = true;
        return true;
    }

    function renderDissolveByProgress(horizontalProgress) {
        if (!canUseDissolve) return;

        if (!isDissolveInitialized) {
            const created = createDissolveScene();
            if (!created) return;
        }

        const dissolveProgress = getDissolveProgress(horizontalProgress);
        dissolveUniforms.uProgress.value = dissolveProgress;
        dissolveRenderer.render(dissolveScene, dissolveCamera);
    }

    function preventScrollEvent(event) {
        event.preventDefault();
    }

    function preventScrollKeys(event) {
        const blockedKeys = ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Space', 'Home', 'End'];
        if (!blockedKeys.includes(event.code)) return;
        event.preventDefault();
    }

    function releaseEndHold() {
        if (holdTimer) {
            window.clearTimeout(holdTimer);
            holdTimer = null;
        }

        window.removeEventListener('wheel', preventScrollEvent, listenerOptions);
        window.removeEventListener('touchmove', preventScrollEvent, listenerOptions);
        window.removeEventListener('keydown', preventScrollKeys, listenerOptions);

        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';

        if (smoother && typeof smoother.paused === 'function') {
            smoother.paused(false);
        }

        isEndHoldActive = false;
    }

    function activateEndHold() {
        if (isEndHoldActive || hasEndHoldCompleted) return;

        isEndHoldActive = true;
        hasEndHoldCompleted = true;

        if (smoother && typeof smoother.paused === 'function') {
            smoother.paused(true);
        }

        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';

        window.addEventListener('wheel', preventScrollEvent, listenerOptions);
        window.addEventListener('touchmove', preventScrollEvent, listenerOptions);
        window.addEventListener('keydown', preventScrollKeys, listenerOptions);

        holdTimer = window.setTimeout(() => {
            releaseEndHold();
        }, HOLD_DURATION);
    }

    function updateLineMaskByProgress(progressX) {
        if (!partnersLine || !partnersLineMask) return;

        const contentRect = partnersContent.getBoundingClientRect();
        const lineRect = partnersLine.getBoundingClientRect();
        const lineStartX = Math.max(0, lineRect.left - contentRect.left);
        const lineWidth = partnersLine.offsetWidth;

        if (lineWidth <= 0) return;

        const lineMaskProgress = Math.min(
            Math.max(progressX - Math.max(0, lineStartX - window.innerWidth), 0),
            lineWidth
        );
        partnersLineMask.style.maxWidth = `${lineMaskProgress}px`;

        // if (partnersLineShip) {
        //     updateShipByProgress(lineMaskProgress / lineWidth);
        // }
    }

    gsapInstance.set(partnersContent, { x: 0 });

    if (partnersLineShip) {
        // 1. Khởi tạo trạng thái ban đầu của tàu
        gsapInstance.set(partnersLineShip, {
            x: 0,
            y: 0,
            rotation: 0,
            willChange: 'transform',
            transformOrigin: '50% 50%',
        });
        // 3. Hàm trợ lý nội bộ để tính khoảng cách pixel trống (maxTravel) thực tế lúc scroll/resize
        const getPixelTravel = () => {
            const lw = partnersLine.offsetWidth;
            return lw;
        };

        const getPixelTravelY = () => {
            const lw = partnersLine.offsetHeight;
            return lw;
        };

        // 2. Tạo Timeline kết hợp ScrollTrigger
        const shipTimeline = gsapInstance.timeline({
            scrollTrigger: {
                trigger: partnersSection,
                start: 'top top',
                end: () => `+=${getPixelTravel()}`,
                scrub: true,
                invalidateOnRefresh: true,
                // onUpdate: function () {
                //     // updateShipByProgress(this.progress);
                // },
            },
        });

        const durationTotal = 1; // Tổng thời lượng timeline (tính theo tỷ lệ phần trăm)

        // 4. Định nghĩa chuỗi chuyển động theo pixel (x) chia làm 3 khoảng
        shipTimeline
            // Khoảng 1: Cuộn từ 0% -> 50% section. Tàu chạy được 50% số pixel tối đa
            .to(partnersLineShip, {
                x: () => getPixelTravel() * 0.4,
                y: () => getPixelTravelY() * 0.1,
                rotation: 15,
                ease: 'none',
                duration: durationTotal * 0.4,
            })
            // Khoảng 2: Cuộn từ 50% -> 70% section. Tàu chạy đến mốc 70% số pixel tối đa
            .to(partnersLineShip, {
                x: () => getPixelTravel() * 0.5,
                y: () => getPixelTravelY() * 0.3,
                rotation: -10,
                ease: 'none',
                duration: durationTotal * 0.3,
            })
            // Khoảng 3: Cuộn từ 70% -> 100% section. Tàu chạy hết 100% số pixel tối đa
            .to(partnersLineShip, {
                x: () => getPixelTravel() - 300,
                y: () => getPixelTravelY() * 0.2,
                rotation: -5,
                ease: 'none',
                duration: durationTotal * 0.3,
            });
    }
    renderDissolveByProgress(0);

    gsapInstance.to(partnersContent, {
        x: () => -getMaxTranslateX(),
        ease: 'none',
        scrollTrigger: {
            trigger: partnersSection,
            start: 'top top',
            end: () => `+=${getMaxTranslateX()}`,
            pin: partnersScroll,
            pinSpacing: true,
            scrub: true,
            anticipatePin: 1,
            invalidateOnRefresh: true,
            onUpdate: self => {
                const maxX = getMaxTranslateX();
                const currentX = self.progress * maxX;

                updateLineMaskByProgress(currentX);
                renderDissolveByProgress(self.progress);
                partnersSection.classList.toggle('partners--scrolled', self.progress > 0.98);

                if (self.progress < 0.95 && !isEndHoldActive) {
                    hasEndHoldCompleted = false;
                }

                if (
                    self.direction > 0 &&
                    self.progress >= 0.999 &&
                    !isEndHoldActive &&
                    !hasEndHoldCompleted
                ) {
                    activateEndHold();
                }

                // set x to partners-scroll__video theo scroll
                const videoEl = partnersSection.querySelector('.partners-scroll__video');
                if (videoEl) {
                    const videoX = maxX * self.progress;
                    videoEl.style.transform = `translate3d(${videoX}px, 0, 0)`;
                }
            },
            onRefresh: () => {
                applyDissolveCanvasSize();
            },
            onKill: () => {
                releaseEndHold();
            },
        },
    });

    window.addEventListener('resize', () => {
        if (!isDissolveInitialized) return;
        applyDissolveCanvasSize();
        dissolveRenderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
        dissolveRenderer.render(dissolveScene, dissolveCamera);
    });
}

function initPartnersVerticalScroll() {
    const canvas = document.querySelector('#dissolve-canvas');
    const partnersSection = document.querySelector('.partners-scroll__images');

    if (!canvas || !partnersSection) return;
    if (typeof window.gsap === 'undefined' || typeof window.ScrollTrigger === 'undefined') return;
    if (typeof window.THREE === 'undefined') return;

    const gsapInstance = window.gsap;
    const ScrollTriggerInstance = window.ScrollTrigger;
    const THREEInstance = window.THREE;

    // Đăng ký Plugin ScrollTrigger
    gsapInstance.registerPlugin(ScrollTriggerInstance);

    // --- 1. SETUP THREE.JS SCENE ---
    const scene = new THREEInstance.Scene();
    const camera = new THREEInstance.OrthographicCamera(-1, 1, 1, -1, 0, 1);
    const renderer = new THREEInstance.WebGLRenderer({ canvas: canvas, alpha: true });

    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

    // --- 2. SHADER CODES (GLSL) ---
    const vertexShader = `
            varying vec2 vUv;
            void main() {
                vUv = uv;
                gl_Position = vec4(position, 1.0);
            }
        `;
    let fragmentShader = `
            uniform float uProgress;
            varying vec2 vUv;

            float hash(vec2 p) {
                p = fract(p * vec2(123.34, 456.21));
                p += dot(p, p + 45.32);
                return fract(p.x * p.y);
            }

            float noise(vec2 p) {
                vec2 i = floor(p);
                vec2 f = fract(p);
                f = f * f * (3.0 - 2.0 * f);
                float a = hash(i);
                float b = hash(i + vec2(1.0, 0.0));
                float c = hash(i + vec2(0.0, 1.0));
                float d = hash(i + vec2(1.0, 1.0));
                return mix(mix(a, b, f.x), mix(c, d, f.x), f.y);
            }

            void main() {
                vec4 color = vec4(1.0 / 255.0, 51.0 / 255.0, 42.0 / 255.0, 1.0);
                float noiseValue = noise(vUv * 15.0);
                float transitionFactor = noiseValue * 0.4 + vUv.y * 2.2;
                float currentThreshold = uProgress * 3.0;

                if (transitionFactor > currentThreshold) {
                    color.a = 1.0;
                } else {
                    color.a = 0.0;
                }
                gl_FragColor = color;
            }
        `;

    // Biến truyền vào Shader (Uniforms)
    const shaderUniforms = {
        uProgress: { value: 0.0 },
    };

    const geometry = new THREEInstance.PlaneGeometry(2, 2);
    const material = new THREEInstance.ShaderMaterial({
        vertexShader: vertexShader,
        fragmentShader: fragmentShader,
        uniforms: shaderUniforms,
        transparent: true,
    });

    const mesh = new THREEInstance.Mesh(geometry, material);
    scene.add(mesh);

    // --- 3. RÁP NỐI VÀO GSAP SCROLLTRIGGER (Đã tối ưu cho Smoother) ---
    gsapInstance.to(shaderUniforms.uProgress, {
        value: 1.0,
        scrollTrigger: {
            trigger: partnersSection,
            start: `top bottom`, // Bắt đầu khi phần tử partnersSection chạm đáy màn hình
            end: `bottom top`, // Kết thúc khi phần tử partnersSection chạm đỉnh + 2000px
            scrub: true, // Chuyển từ scrub: 1 thành true. Vì bản thân ScrollSmoother đã có độ trễ mượt sẵn (smooth), bạn để scrub: true sẽ giúp shader phản hồi real-time chính xác theo mượt của smoother, tránh bị "trễ chồng trễ" (double lag).
        },
        // Loại bỏ hàm onUpdate ở đây, chuyển hoàn toàn việc vẽ vào vòng lặp animate()
    });

    // --- 4. XỬ LÝ RESIZE TRÌNH DUYỆT ---
    window.addEventListener('resize', () => {
        renderer.setSize(window.innerWidth, window.innerHeight);
        renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    });

    // --- 5. VÒNG LẶP ANIMATION HOÀN CHỈNH ---
    function animateMobile() {
        requestAnimationFrame(animateMobile);
        renderer.render(scene, camera);
    }

    // Kích hoạt vòng lặp vẽ
    animateMobile();
}

function initPartnersScrollMobile() {
    const gsapInstance = window.gsap;
    const lineMobileWrapper = document.getElementById('partners-scroll__line-mobile');
    if (!lineMobileWrapper) return;
    // console.log(lineMobileWrapper);
    const lineMobileMask = lineMobileWrapper.querySelector('.partners-scroll__line-mobile-mask');

    if (lineMobileMask) {
        gsapInstance.fromTo(
            lineMobileMask,
            {
                clipPath: 'inset(0% 0% 100%)',
            },
            {
                clipPath: 'inset(0% 0% 0%)',
                scrollTrigger: {
                    trigger: lineMobileWrapper,
                    start: `top center`,
                    end: `bottom center`,
                    scrub: true,
                },
            }
        );
    }

    // tạo transform scroll cho .partners-scroll__line-mobile-ship khi scroll theo dạng dọc trong section partners-scroll__line-mobile
    const lineMobileShip = document.querySelector('.partners-scroll__line-mobile-ship');

    if (lineMobileShip && typeof lineMobileWrapper !== 'undefined') {
        // 1. Tạo một Timeline và gắn ScrollTrigger vào toàn bộ timeline đó
        const tl = gsapInstance.timeline({
            scrollTrigger: {
                trigger: lineMobileWrapper,
                start: `top center`,
                end: `bottom center`,
                scrub: true,
            },
        });

        // Định nghĩa các giá trị đích cuối cùng để tính toán cho mốc 70%
        const targetX = lineMobileWrapper.offsetWidth - lineMobileShip.offsetWidth; // vị trí x cuối cùng của lineMobileShip
        const targetY = lineMobileWrapper.offsetHeight - lineMobileShip.offsetHeight; // vị trí y cuối cùng của lineMobileShip
        // console.log('targetX:', targetX, 'targetY:', lineMobileShip.offsetWidth);

        tl.set(lineMobileShip, {
            y: 0,
            x: 0,
            rotation: 55,
        });

        tl.to(
            lineMobileShip,
            {
                x: targetX * 0.6,
                y: targetY * 0.5,
                rotation: 55,
                duration: 0.5,
            },
            0
        );

        tl.to(
            lineMobileShip,
            {
                x: targetX * 0.5,
                y: targetY * 0.8,
                rotation: 95,
                duration: 0.3,
            },
            0.5
        );

        tl.to(
            lineMobileShip,
            {
                x: targetX,
                y: targetY,
                rotation: 25,
                duration: 0.2,
            },
            0.8
        );
    }
}

function initHeroPinAnimation(smoother) {
    if (typeof window.gsap === 'undefined') return;

    const heroSection = document.querySelector('.hero');
    const bannerSection = document.querySelector('.banner');
    const bannerWrapper = bannerSection ? bannerSection.querySelector('.banner__wrapper') : null;

    if (!heroSection) return;

    const heroWrapper = heroSection.querySelector('.hero__wrapper');
    const intersectEl =
        heroSection.querySelector('.intersect') || document.querySelector('.intersect');

    if (!intersectEl) {
        console.warn('Không tìm thấy phần tử .intersect');
        return;
    }

    document.body.classList.remove('website--active');

    const viewWidth = window.innerWidth || document.documentElement.clientWidth;
    let maskSize = viewWidth < 991 ? '600%' : '400%';

    function getBannerTargetRect() {
        if (!bannerSection || !bannerWrapper) return null;

        const bannerRect = bannerSection.getBoundingClientRect();
        const wrapperRect = bannerWrapper.getBoundingClientRect();

        return {
            top: wrapperRect.top - bannerRect.top,
            left: wrapperRect.left,
            width: wrapperRect.width,
            height: wrapperRect.height,
        };
    }

    let targetRect = getBannerTargetRect();

    const textElements = heroSection.querySelectorAll(
        '.hero__title, .hero__text, .hero__inner span'
    );

    if (textElements.length > 0) {
        gsap.set(textElements, {
            opacity: 0,
            y: 40,
        });

        const playToAnimation = () => {
            gsap.to(textElements, {
                opacity: 1,
                y: 0,
                duration: 3,
                stagger: 0.6,
                ease: 'power2.out',
            });
        };
        window.addEventListener('loadingComplete', () => {
            playToAnimation();
        });
    }

    const tl = gsap.timeline({
        defaults: { ease: 'none' },
        scrollTrigger: {
            trigger: heroSection,
            start: 'top top',
            end: 'bottom top',
            pin: true,
            pinSpacing: true,
            scrub: true,
            invalidateOnRefresh: true,
        },
    });

    tl.to(
        intersectEl,
        {
            webkitMaskSize: maskSize,
            maskSize: maskSize,
            ease: 'none',
            duration: 0.5,
        },
        0
    );

    tl.to(
        heroWrapper,
        {
            x: targetRect ? targetRect.left : 0,
            y: targetRect ? targetRect.top : 0,
            width: targetRect ? targetRect.width : '100%',
            height: targetRect ? targetRect.height : '100%',
            borderRadius: '24px',
            ease: 'none',
            duration: 0.3,
            onComplete: () => {
                if (!document.body.classList.contains('website--active')) {
                    document.body.classList.add('website--active');
                }
            },
            onReverseComplete: () => {
                if (document.body.classList.contains('website--active')) {
                    document.body.classList.remove('website--active');
                }
            },
        },
        0.5
    );

    tl.to({}, { duration: 1.5 }, 0.9);
}

function initCollectionsInfiniteScroll() {
    const section = document.querySelector('.products-listing[data-infinite-scroll="true"]');
    if (!section) return;

    const list = section.querySelector('.product__lists');
    const countEl = section.querySelector('.products-listing__count');
    if (!list) return;

    let sentinel = section.querySelector('[data-infinite-sentinel]');
    if (!sentinel) {
        sentinel = document.createElement('div');
        sentinel.className = 'products-listing__sentinel';
        sentinel.setAttribute('data-infinite-sentinel', '');
        sentinel.setAttribute('aria-hidden', 'true');
        list.appendChild(sentinel);
    }

    let nextLink = section.querySelector('[data-next-page-url]');
    let nextUrl = nextLink ? nextLink.getAttribute('href') : '';
    let isLoading = false;
    let activeRequestId = 0;

    function setCollectionLoadingState(isActive) {
        section.classList.toggle('is-collection-loading', isActive);
        section.setAttribute('aria-busy', isActive ? 'true' : 'false');
    }

    function resolveNextUrl(doc) {
        const nextAnchor = doc.querySelector('.products-listing [data-next-page-url]');
        return nextAnchor ? nextAnchor.getAttribute('href') : '';
    }

    function updateNextLink(url) {
        nextUrl = url || '';

        if (nextUrl) {
            if (!nextLink) {
                nextLink = document.createElement('a');
                nextLink.hidden = true;
                nextLink.setAttribute('aria-hidden', 'true');
                nextLink.setAttribute('data-next-page-url', '');
                list.appendChild(nextLink);
            }
            nextLink.setAttribute('href', nextUrl);
            if (sentinel.parentNode !== list) {
                list.appendChild(sentinel);
            }
            observer.observe(sentinel);
            return;
        }

        if (nextLink && nextLink.parentNode) {
            nextLink.parentNode.removeChild(nextLink);
            nextLink = null;
        }
        observer.unobserve(sentinel);
        if (sentinel.parentNode) {
            sentinel.parentNode.removeChild(sentinel);
        }
    }

    function setActiveCollectionItem(activeItem) {
        const items = section.querySelectorAll('.products-listing__collection-item');
        items.forEach(item => {
            item.classList.remove('collection-active');
        });
        activeItem.classList.add('collection-active');
    }

    const observer = new IntersectionObserver(
        entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    loadMoreProducts();
                }
            });
        },
        {
            root: null,
            rootMargin: '300px 0px',
            threshold: 0.01,
        }
    );

    async function loadMoreProducts() {
        if (isLoading || !nextUrl) return;

        isLoading = true;
        const requestId = ++activeRequestId;

        try {
            const response = await fetch(nextUrl, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            if (!response.ok) {
                observer.disconnect();
                return;
            }

            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            if (requestId !== activeRequestId) {
                return;
            }

            const incomingList = doc.querySelector('.products-listing .product__lists');
            if (!incomingList) {
                observer.disconnect();
                return;
            }

            const incomingItems = incomingList.querySelectorAll('.product-item');
            incomingItems.forEach(item => {
                list.appendChild(item);
            });

            updateNextLink(resolveNextUrl(doc));
        } catch (error) {
            observer.disconnect();
        } finally {
            isLoading = false;
        }
    }

    section.addEventListener('click', async event => {
        const item = event.target.closest('.products-listing__collection-item');
        if (!item || !section.contains(item)) return;

        event.preventDefault();
        if (isLoading) return;

        const targetUrl = item.getAttribute('href');
        if (!targetUrl) return;

        isLoading = true;
        setCollectionLoadingState(true);
        const requestId = ++activeRequestId;

        try {
            const response = await fetch(targetUrl, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            if (!response.ok) {
                return;
            }

            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            if (requestId !== activeRequestId) {
                return;
            }

            const incomingList = doc.querySelector('.products-listing .product__lists');
            if (!incomingList) {
                return;
            }
            if (incomingList.innerHTML.trim() === '') {
                incomingList.innerHTML = '<div class="coming-soon">Coming soon</div>';
            }
            list.innerHTML = incomingList.innerHTML;

            setActiveCollectionItem(item);

            const incomingCountEl = doc.querySelector('.products-listing .products-listing__count');
            if (countEl && incomingCountEl) {
                countEl.textContent = incomingCountEl.textContent;
            }

            updateNextLink(resolveNextUrl(doc));
        } catch (error) {
            observer.disconnect();
        } finally {
            isLoading = false;
            setCollectionLoadingState(false);
        }
    });

    if (nextUrl) {
        observer.observe(sentinel);
    }
}

function menuToggle() {
    const menuToggleButton = document.querySelector('.menu-toggle');
    const header = document.getElementById('header');
    if (!menuToggleButton || !header) return;

    menuToggleButton.addEventListener('click', e => {
        e.preventDefault();
        const isMenuOpen = header.classList.toggle('menu--open');
        menuToggleButton.setAttribute('aria-expanded', isMenuOpen ? 'true' : 'false');
        document.body.classList.toggle('menu-open', isMenuOpen);
    });
}

function loadLottieAnimation(containerId, jsonPath) {
    const container = document.getElementById(containerId);
    if (!container) return;

    container.style.opacity = '0'; // Ẩn container ngay từ đầu
    container.style.transition = 'opacity 0.5s ease-in-out'; // Thêm hiệu ứng mờ dần

    const animation = lottie.loadAnimation({
        container: container,
        renderer: 'canvas',
        loop: true,
        autoplay: true,
        path: jsonPath,
    });

    animation.addEventListener('DOMLoaded', () => {
        container.style.opacity = '1'; // Hiện container khi Lottie đã tải xong
    });
}

function homeLottieAnimations() {
    const isMobile = window.matchMedia('(max-width: 991px)').matches;
    if (!isMobile) return; // Không chạy Lottie trên mobile
    let isScrollTriggerReady = false;
    let lottieAnimation = null; // Tạo biến toàn cục để quản lý
    const container = document.getElementById('lottie-canvas-container');
    if (!container) return;
    function initLottie() {
        container.style.opacity = '0'; // Ẩn container ngay từ đầu
        container.style.transition = 'opacity 0.5s ease-in-out'; // Thêm hiệu ứng mờ dần
        const jsonPath = container ? container.getAttribute('data-lottie-path') : null;
        if (lottieAnimation) {
            lottieAnimation.destroy();
        }
        lottieAnimation = lottie.loadAnimation({
            container: container,
            renderer: 'canvas',
            loop: true,
            autoplay: true,
            path: jsonPath, // Nhớ đổi tên file này thành file của bạn
        });
    }
    function playLottieOnce() {
        if (lottieAnimation && lottieAnimation.isPaused) {
            lottieAnimation.play();
            // console.log(lottieAnimation)

            // Hủy lắng nghe để các lần refresh sau của ScrollTrigger không kích hoạt lại nữa
            window.ScrollTrigger.removeEventListener('refresh', playLottieOnce);
            setTimeout(
                () => {
                    container.style.opacity = '1'; // Hiện container khi Lottie bắt đầu chạy
                },
                isMobile ? 1500 : 2000
            ); // Delay để Lottie có thời gian khởi động trước khi hiển thị
        }
    } // Chạy theo đúng thứ tự:
    initLottie(); // 1. Khởi tạo và bắt nằm im
    window.ScrollTrigger.addEventListener('refresh', playLottieOnce);
}

// functions
(function () {
    const isMobile = window.matchMedia('(max-width: 991px)').matches;

    gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
    let smoother = null;
    ScrollTrigger.config({
        ignoreMobileResize: true,
    });

    if (isMobile) {
        smoother = null; // Không sử dụng ScrollSmoother trên mobile
    } else {
        smoother = ScrollSmoother.create({
            wrapper: '#smooth-wrapper', // Định nghĩa khung nhìn
            content: '#smooth-content', // Định nghĩa nội dung cuộn
            smooth: 1.5, // Thời gian làm mượt (giây). Số càng lớn cuộn càng mượt và trễ.
            // smoothTouch: 0.1, // QUAN TRỌNG: Giảm độ trễ mượt trên mobile xuống rất thấp (hoặc để false)
            effects: true, // Bật tính năng nhận diện thuộc tính data-speed (Parallax)
        });
    }
    initHeroPinAnimation(smoother);
    initGsapTextReveal('reveal-zone');
    initFadeInOnScroll([
        '.product__title',
        '.product-item__location',
        '.product-item__title',
        '.product-item__description',
        '.product__more',
        '.btn--icon',
        '.btn__icon',
        '.why__captions',
        '.why__title',
        '.why__images',
        '.why-item__icon',
        '.why-item__title',
        '.why-item__description',
        '.footer-contact__logo',
        '.footer-contact__title',
        '.footer-contact__description',
        '.footer-contact__buttons .btn',
        '.footer-contact__image',
        '.footer-content__title',
        '.footer-content__list',
        // '.footer-content__social-link',
        // '.footer-copyright',
        '.about-us-page__heading--left',
        '.about-us-page__heading--right',
        '.about-us-page__image-el',
        '.about-info__caption',
        '.about-info__text',
        '.our-vision__caption',
        '.our-vision__heading',
        '.our-vision__image-el',
        '.our-commitment__caption',
        '.our-commitment__image-el',
        '.our-commitment__count',
        '.our-commitment__item-heading',
        '.our-commitment__item-text',
        '.news-related__heading',
        '.news-card__image',
        '.news-card__title',
        '.news-card__meta',
        '.wholesale-page__heading',
        '.partner-section__vision-tag',
        '.partner-section__image',
        '.partner-section__title',
        '.partner-section__item-title',
        '.partner-section__description',
        '.contact-form__label',
        '.contact-form__input',
        '.contact-form__select-wrapper',
    ]);
    initAboutsIconScrollSwap();
    initCanvasDissolve();
    // initBannerIconPhysicalEvade();
    if (!isMobile) {
        initPartnersHorizontalScroll(smoother);
        // initPartnersScroll(smoother);
    } else {
        initPartnersVerticalScroll();
        initPartnersScrollMobile();
        initFadeInOnScroll([
            '.partners-scroll__images',
            '.partners-scroll__line',
            '.partners-scroll__ship',
        ]);
    }

    // Collections infinite scroll vẫn chạy trên mobile (không dùng GSAP)
    initCollectionsInfiniteScroll();

    menuToggle();

    // Giải pháp cứu cánh cho iPhone
    // window.ScrollTrigger.addEventListener('refresh', () => {
    //     // Bây giờ mới cho phép Lottie chạy
    //     console.log("ScrollTrigger đã xử lý xong!");
    //     animation.setSubframe(false);
    //     animation.play();
    // });

    // check product-detail__gallery
    const productGallery = document.querySelector('.product-detail__gallery');
    const productDetail = document.querySelector('.product-detail');

    if (productGallery && productDetail && !isMobile) {
        console.log('productGallery found', productGallery);

        // Kích hoạt plugin ScrollTrigger
        gsap.registerPlugin(ScrollTrigger);

        ScrollTrigger.create({
            trigger: productGallery, 
            endTrigger: productDetail,
            start: 'top top',
            end: 'bottom bottom',
            pin: true,
            pinSpacing: false, 
            invalidateOnRefresh: true,
        });
    }

    homeLottieAnimations();

    const aboutLottieContainer = document.getElementById('about-us-lottie-animation');
    const aboutLottiePath = aboutLottieContainer
        ? aboutLottieContainer.getAttribute('data-lottie-path')
        : null;
    if (aboutLottieContainer && aboutLottiePath) {
        loadLottieAnimation('about-us-lottie-animation', aboutLottiePath);
    }
})();
